.flickr {
    margin: 0 auto;
    width: 150px;
}

.badge {
    border: solid 1px #000000;
    background-color: #ffffff;
    color: #666666;
    text-align: center;
    font-family: arial, helvetica, sans-serif;
    font-size: 11px;
}

/* The badge keeps Flickr's own link colours over the site-wide link rules. */
.badge a,
.badge a:hover,
.badge a:visited {
    /* biome-ignore lint/complexity/noImportantStyles: must beat the global link styles */
    color: #3993ff !important;
    /* biome-ignore lint/complexity/noImportantStyles: must beat the global link styles */
    background: inherit !important;
    /* biome-ignore lint/complexity/noImportantStyles: must beat the global link styles */
    text-decoration: none !important;
}

.header {
    margin: 5px auto;
}

.frame {
    margin: 5px 15px;
    height: 313px;
}

.itemsShown,
.itemsHidden {
    transition: opacity 1000ms;
}
.itemsShown {
    opacity: 1;
}
.itemsHidden {
    opacity: 0;
}

.item {
    width: 100%;
    height: 100px;
    line-height: 98px;
    border: solid 1px #cccccc;
    margin: 3px auto;
}

.thumbnail {
    max-width: 100%;
    max-height: 100px;
    vertical-align: middle;
}

.footer {
    margin: 0 10px 5px 10px;
}
